import apiClient from './apiClient';

export interface Payment {
  id: number;
  amount: number;
  currency: string;
  status: string;
  paymentMethod: string;
  transactionId: string;
  subscriberId: number;
  subscriptionId?: number;
  createdAt: Date;
}

export interface PaymentFilters {
  amountMin?: number;
  amountMax?: number;
  dateMin?: Date;    
  dateMax?: Date;
  method?: string;
  status?: string;
  description?: string;
  agencyName?: string;
}

export interface PaginationParams {
  page?: number; 
  size?: number;
  filters?: PaymentFilters;
}

export const paymentService = {

  getStats: () => apiClient.get('/v1/payments/stats'),

  getStatsAgency: () => apiClient.get('/v1/payments/stats/agency'),

  getAllAdmin: (params?: PaginationParams) => 
    {
    const { page, size, filters } = params || {};

    return apiClient.get('/v1/payments/admin/all', {
      params: {
        page,
        size,
        ...filters,
      },
    });
  },

  getAllAgency: (params?: PaginationParams) => 
    {
    const { page, size, filters } = params || {};

    return apiClient.get('/v1/payments/agency/all', {
      params: {
        page,
        size,
        ...filters,
      },
    });
  },

  getAll: () => 
    apiClient.get('/v1/payments'),

  getBySubscriber: (subscriberId: number) =>
    apiClient.get(`/payments/subscriber/${subscriberId}`),

  processPayment: (paymentData: Omit<Payment, 'id' | 'status' | 'createdAt'>) =>
    apiClient.post('/payments/process', paymentData),

  refund: (paymentId: number, reason: string) =>
    apiClient.post(`/payments/${paymentId}/refund`, { reason }),

  verifyPayment: (transactionId: string) =>
    apiClient.get(`/payments/verify/${transactionId}`)
};